import type { NextRouter } from 'next/router'
import { paths } from '@mc/paths'
import { PageSource } from '@mc/track-event'
import { getSkillCategoryNameBySlug } from 'pages/for-business/skills/libs'

const MAW_PAGE_SOURCE_MAP: Record<string, string> = {
  [paths.enterpriseHomepage]: PageSource.MAW_HOME,
  [paths.enterpriseAccelerator]: PageSource.MAW_ACCELERATOR,
  [paths.enterpriseCollective]: PageSource.MAW_COLLECTIVE,
  [paths.enterprisePurchase]: PageSource.MAW_PURCHASE,
  [paths.enterpriseSkillsLibrary]: PageSource.LIBRARY,
}

const isSkillPage = (path: string) =>
  path.startsWith(paths.enterpriseSkillCategory(''))

const getSkillPageSource = (skillSlug: string) =>
  `MAW Skills:${getSkillCategoryNameBySlug(skillSlug)}`

export const getPageSourceFromPath = ({
  pathname,
  query,
}: Pick<NextRouter, 'pathname' | 'query'>) =>
  isSkillPage(pathname)
    ? getSkillPageSource((query.slug as string) || '')
    : MAW_PAGE_SOURCE_MAP[pathname]

export const shouldHideEnterpriseCTAInNav = (pathname: string) =>
  ([paths.enterprisePurchase, paths.enterpriseCart] as string[]).includes(
    pathname,
  )

export const shouldScrollToForm = (pathname: string) =>
  pathname === paths.enterpriseHomepage ||
  pathname === paths.enterpriseCollective ||
  pathname === paths.enterpriseAccelerator ||
  pathname.startsWith(paths.enterpriseSkillCategory(''))
